document.addEventListener('DOMContentLoaded', function () {
    var thumbs = document.querySelectorAll('.product__gallery__thumb');
    var heroPicture = document.getElementById('gallery-hero-picture');
    var heroLink = document.querySelector('.product__gallery__hero');
    var thumbsContainer = document.querySelector('.product__gallery__thumbs');
    var arrowLeft = document.querySelector('.product__gallery__arrow--left');
    var arrowRight = document.querySelector('.product__gallery__arrow--right');
    var lightbox = null;
    var currentIndex = 0;

    if (!thumbs.length || !heroPicture) return;

    var sources = heroPicture.querySelectorAll('source');
    var heroImg = heroPicture.querySelector('img');

    if (typeof GLightbox !== 'undefined') {
        lightbox = GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            loop: true,
            startAt: 0
        });

        if (heroLink) {
            heroLink.addEventListener('click', function (e) {
                e.preventDefault();
                lightbox.openAt(currentIndex);
            });
        }
    }

    thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var active = document.querySelector('.product__gallery__thumb.active');
            if (active) active.classList.remove('active');
            thumb.classList.add('active');

            currentIndex = parseInt(thumb.getAttribute('data-index'), 10);
            var s780 = thumb.getAttribute('data-src-780');
            var s570 = thumb.getAttribute('data-src-570');
            var s950 = thumb.getAttribute('data-src-950');
            var s1140 = thumb.getAttribute('data-src-1140');
            var s1560 = thumb.getAttribute('data-src-1560');
            var s1900 = thumb.getAttribute('data-src-1900');

            if (sources.length >= 4) {
                sources[0].setAttribute('srcset', s780 + ' 1x, ' + s1560 + ' 2x');
                sources[1].setAttribute('srcset', s570 + ' 1x, ' + s1140 + ' 2x');
                sources[2].setAttribute('srcset', s950 + ' 1x, ' + s1900 + ' 2x');
                sources[3].setAttribute('srcset', s780 + ' 1x, ' + s1560 + ' 2x');
            }

            if (heroImg) {
                heroImg.setAttribute('src', s950);
            }

            if (heroLink) {
                heroLink.setAttribute('href', s1900);
            }

            if (lightbox) {
                lightbox.openAt(currentIndex);
            }
        });
    });

    if (arrowLeft && arrowRight && thumbsContainer) {
        var scrollAmount = 160;

        arrowLeft.addEventListener('click', function () {
            thumbsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        arrowRight.addEventListener('click', function () {
            thumbsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
    }
});
